import { render, staticRenderFns } from "./coursedetails.vue?vue&type=template&id=5c35347f&scoped=true"
import script from "./coursedetails.vue?vue&type=script&lang=js"
export * from "./coursedetails.vue?vue&type=script&lang=js"
import style0 from "./coursedetails.vue?vue&type=style&index=0&id=5c35347f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c35347f",
  null
  
)

export default component.exports